export const theme = {
  filtersContainerPadding: '0.5rem',
  moreOptionsTextTransform: Styles.textTransform.headlines,
  titleLineHeight: 1.2,
};
